/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInnerErrors } from './get-payment-request-evidence-records200-response-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInnerFile } from './get-payment-request-evidence-records200-response-inner-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer } from './get-payment-request-evidence-records200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy } from './get-payment-request-evidence-records200-response-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy } from './get-payment-request-evidence-records200-response-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInnerWarnings } from './get-payment-request-evidence-records200-response-inner-warnings';

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInner
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'paymentType': GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'electronicMethod': GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'documentSize': GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'legalValidity': GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerFile}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'file': GetPaymentRequestEvidenceRecords200ResponseInnerFile;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'invoiceIssuer': GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerErrors}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'errors': GetPaymentRequestEvidenceRecords200ResponseInnerErrors;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerWarnings}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'warnings': GetPaymentRequestEvidenceRecords200ResponseInnerWarnings;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'updatedBy': GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedBy': GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedFrom': string;
}

export const GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum];


